import { render, staticRenderFns } from "./ListaTerritoriosImportados.vue?vue&type=template&id=38a21afd&lang=pug"
import script from "./ListaTerritoriosImportados.vue?vue&type=script&lang=js"
export * from "./ListaTerritoriosImportados.vue?vue&type=script&lang=js"
import style0 from "./ListaTerritoriosImportados.vue?vue&type=style&index=0&id=38a21afd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports